import React, { Component } from 'react';
import Contact from './contact';

export default class Header extends Component {
  render() {
    return (
        <>
        <div style={{ backgroundColor: 'rgba(33, 37, 41, 0.45)', backdropFilter: 'blur(4px)', borderBottom: '1px solid rgba(255, 255, 255, 0.1)', padding: '15px 20px', borderRadius: '0 0 10px 10px', marginBottom: '20px' }}>
            <header className="d-flex justify-content-end align-items-center pt-1 text-light">
            <nav className="d-flex align-items-center">
                <a href="/#features" className="text-info text-decoration-none">Features</a>
                <a href="/#get-started" className="text-info text-decoration-none ms-3">Get Started</a>
                <a href="/#support" className="text-info text-decoration-none ms-3">Support</a>
                <a href="/about" className="text-info text-decoration-none ms-3">About</a>
                <button
                  className="btn btn-link text-info text-decoration-none ms-3 p-0"
                  data-bs-toggle="modal"
                  data-bs-target="#contactModal"
                >Contact</button>
                <button
                  className="btn btn-outline-info btn-sm ms-4"
                  data-bs-toggle="modal"
                  data-bs-target="#deployModal"
                >Deployment Guide</button>
            </nav>
            </header>
        </div>
        <Contact />
        </>
    );
  }
}
